import React from 'react'
import styled from 'styled-components/macro'

export const OLLIE_RETRY_COPY = Object.freeze({
  button: 'Retry',
  error: "Ollie couldn't answer that one.",
})

/**
 * Under a reply Ollie didn't finish (timed out) or a send that failed:
 * one quiet Retry that asks the same question again.
 */
const OllieRetryRow = ({ reason, onRetry, disabled = false }) => (
  <Row data-testid='ollie-retry' data-reason={reason}>
    {reason === 'error' && <Hint>{OLLIE_RETRY_COPY.error}</Hint>}
    <RetryButton
      type='button'
      onClick={onRetry}
      disabled={disabled}
      data-testid='ollie-retry-button'
    >
      {OLLIE_RETRY_COPY.button}
    </RetryButton>
  </Row>
)

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: -4px 0 14px;
`

const Hint = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colours.oliveGrey};
`

const RetryButton = styled.button`
  border: 1px solid ${({ theme }) => theme.colours.panSilver};
  background: ${({ theme }) => theme.colours.mayoWhite};
  color: ${({ theme }) => theme.colours.bbqBlack};
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`

export default OllieRetryRow
